// extracted by mini-css-extract-plugin
export default {"banner":"BetaWebsiteBanner_banner__nTaPV","inner":"BetaWebsiteBanner_inner__d6-zl"};